import { useState } from 'react';

export function useMutate(cb: (...args: any) => Promise<any>) {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<Error | null>(null);

	async function mutate(...args: any) {
		try {
			setLoading(true);
			await new Promise((res) =>
				setTimeout(() => {
					res('');
				}, 300),
			);
			const res = await cb(...args);
			return res;
		} catch (e) {
			setError(e);
			throw e;
		} finally {
			setLoading(false);
		}
	}

	return { loading, error, mutate };
}
